import { useDispatch } from "react-redux";

export default function useAppDispatch() {
    return useDispatch<any>();
}
